// extracted by mini-css-extract-plugin
module.exports = {"root":"TermsAndConditions_root__mrZPh","controls":"TermsAndConditions_controls__2OZG6"};